import React from 'react';
import {connect} from 'react-redux';
import {Field, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form'
import {Button, Card, CardBody, Col, FormGroup} from 'reactstrap';
import validate, {SearchModelRuleParams} from "./validate";
import {AppState} from "@Redux/store";
import ReduxFormSelect from "@Utils/ReduxFormSelect";
import {ArmyView} from "@Selectors/builder/myBuilder/builder/new/view/ArmyView";
import ReduxFormAutocomplete from "@Utils/ReduxFormAutocomplete";
import {EntityId} from "@Models";
import {VersionGameView} from "@Selectors/common/view/VersionGameView";
import {VersionGame} from "@Models";
import ReduxFormCategorySelect from "@Utils/ReduxFormCategorySelect";
import {ModelRuleView} from "@Selectors/searchModelRule/make/view/ModelRuleView";
import { defaultMessages } from '@I18n/default';

interface Props {
  versions: Array<VersionGameView>,
  armies: Array<ArmyView>,
  rules?: Array<ModelRuleView>,
  loadRules: ({versionId, armyIds}: { versionId: number, armyIds: Array<number> }) => void,
  onSubmit: (values: SearchModelRuleParams) => void,
  onChange: (event: any, newValue: any, previousValue: any, name: any) => void,
  handleOnSelect: (item: EntityId<number>) => void,
  canSubmit: boolean,
}

export const Form: React.FC<Props & InjectedFormProps<SearchModelRuleParams, Props>> = ({
                                                                                            versions,
                                                                                            armies,
                                                                                            rules,
                                                                                            onChange,
                                                                                            handleOnSelect,
                                                                                            handleSubmit,
                                                                                            canSubmit
                                                                                          }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Col sm="12">
        <Card className="card-border">
          <CardBody>
            <h2 className="text-center">Search an army list</h2>

            <FormGroup row={true}>
              <Col xs="12" md={6} lg="4">
                <Field
                  name="versionId"
                  type="text"
                  datas={versions}
                  component={ReduxFormCategorySelect}
                  onChange={onChange}
                  label={defaultMessages.armyListFormVersionTitle}
                  placeHolder={defaultMessages.armyListFormVersionPlaceholder}
                />
              </Col>
              <Col xs="12" md={6} lg="4">
                <Field
                  name="armyIds"
                  datas={armies}
                  multiple={true}
                  type="select-multiple"
                  component={ReduxFormSelect}
                  onChange={onChange}
                  label={defaultMessages.armyListFormArmyTitle}
                  placeHolder={defaultMessages.armyListFormArmyPlaceholder}
                />
              </Col>
            </FormGroup>

            <FormGroup row={true}>
              <Col xs="12" md={6} lg={6}>
                <Field
                  name="modelRuleId"
                  datas={rules}
                  component={ReduxFormAutocomplete}
                  handleOnSelect={handleOnSelect}
                  label={defaultMessages.activerecordAttributesNinthAgeUnitOptionCategorySpecialrule}
                  placeHolder={defaultMessages.activerecordAttributesNinthAgeUnitOptionCategorySpecialrule}
                />
              </Col>
            </FormGroup>

          </CardBody>
          <div className="mb-2 text-center">
            <Button disabled={!canSubmit} color="age" type="submit">Search</Button>
          </div>
        </Card>
      </Col>
    </form>
  );
}

const SearchModelRuleForm = reduxForm<SearchModelRuleParams, Props>({
  form: 'search_special_rule',
  validate,
})(Form);

// Decorate with connect to read form values
// @ts-ignore
const selector = formValueSelector('search_special_rule') // <-- same as form name

const mapStateToProps = (state: AppState, props: Props) => {
  // can select values individually
  let version = selector(state, 'versionId') ?? null;
  let army = selector(state, 'armyIds') ?? new Array<number>();
  if (!version) {
    version = props.versions
      .flatMap(item => item.options)
      .filter(item => item.game === VersionGame.NinthAge)
      .sort((a, b) => b.id - a.id)
      .slice(0, 1)
      .shift()
      ?.id;

    army = [props.armies.filter(item => version != null && item.versionId == version)
      .slice(0, 1)
      .shift()
      ?.id]

    props.loadRules({versionId: version, armyIds: army});
  }
  return {
    versions: props.versions,
    armies: props.armies.filter(item => version != null && item.versionId == version),
    rules: props.rules ?? selector(state, 'rules') ?? new Array<ModelRuleView>(),
    onSubmit: props.onSubmit,
    initialValues: {
      versionId: version,
      armyIds: army,
    },
    enableReinitialize: true,
  }
}

export default connect(mapStateToProps)(SearchModelRuleForm);
